import { useId } from 'react';

/** Distinctive stacked-layer “L” mark in Bambu green on navy. */
export function LogoMark({
  size = 24,
  className,
  title = 'Layerforge',
}: {
  size?: number;
  className?: string;
  title?: string;
}) {
  const uid = useId().replace(/:/g, '');
  const bg = `lfBg-${uid}`;
  const sheen = `lfSheen-${uid}`;
  const layer = `lfLayer-${uid}`;
  const hi = `lfHi-${uid}`;
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden={title ? undefined : true}
      role={title ? 'img' : undefined}
    >
      {title ? <title>{title}</title> : null}
      <defs>
        <linearGradient id={bg} x1="12" y1="2" x2="56" y2="62" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#2c3660" />
          <stop offset="0.55" stopColor="#1a2342" />
          <stop offset="1" stopColor="#12182f" />
        </linearGradient>
        <linearGradient id={sheen} x1="32" y1="2" x2="32" y2="34" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#fff" stopOpacity="0.28" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient id={layer} x1="10" y1="10" x2="54" y2="52" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#5AF096" />
          <stop offset="0.38" stopColor="#00AE42" />
          <stop offset="1" stopColor="#007A2E" />
        </linearGradient>
        <linearGradient id={hi} x1="16" y1="12" x2="44" y2="24" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#fff" stopOpacity="0.55" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
      </defs>
      <rect width="64" height="64" rx="14" fill={`url(#${bg})`} />
      <rect x="1.25" y="1.25" width="61.5" height="30" rx="13" fill={`url(#${sheen})`} />
      <path d="M15 17.5 L33.5 15.2 L37.8 20.2 L19.4 22.6 Z" fill={`url(#${layer})`} />
      <path d="M33.5 15.2 L37.8 20.2 L37.8 23.4 L33.5 18.4 Z" fill="#006627" />
      <path d="M15 17.5 L19.4 22.6 L19.4 25.6 L15 20.5 Z" fill="#009638" />
      <path d="M16.4 17.8 L32.6 16 L35.2 19.2" stroke={`url(#${hi})`} strokeWidth="1.15" strokeLinecap="round" />
      <path d="M15 27.6 L39.5 25.1 L43.8 30.2 L19.4 32.8 Z" fill={`url(#${layer})`} />
      <path d="M39.5 25.1 L43.8 30.2 L43.8 33.4 L39.5 28.3 Z" fill="#006627" />
      <path d="M15 27.6 L19.4 32.8 L19.4 35.8 L15 30.6 Z" fill="#009638" />
      <path d="M16.4 27.9 L38.4 25.8 L41.2 29.1" stroke={`url(#${hi})`} strokeWidth="1.15" strokeLinecap="round" />
      <path d="M15 37.8 L48.2 34.8 L52.6 40.1 L19.4 43.2 Z" fill={`url(#${layer})`} />
      <path d="M48.2 34.8 L52.6 40.1 L52.6 43.4 L48.2 38.1 Z" fill="#006627" />
      <path d="M15 37.8 L19.4 43.2 L19.4 46.2 L15 40.8 Z" fill="#009638" />
      <path d="M16.4 38.1 L47 35.5 L50 38.8" stroke={`url(#${hi})`} strokeWidth="1.15" strokeLinecap="round" />
    </svg>
  );
}
